import { Injectable } from '@angular/core';
import { LazyLoadedWidgets } from 'src/app/app-routing-lazy';
import { ITaskDialogMetadata } from 'src/app/pages/member/+components/tasks/member-task-dialog/member-task-dialog.models';
import { ITaskCommandWrapper, TaskInfo } from 'src/app/services/task/task.state.models';
import {
    ITaskInterviewMetadata
} from 'src/app/shared/interview-new/instances/task-adapter-interview/task-adapter-interview.models';
import { ILazyLoadContext } from 'src/app/shared/lazy-loader/lazy-loader.models';
import { InjectorInstance } from './../../global/global.service';

import { Router } from '@angular/router';
import { IInterviewConfig } from 'src/app/shared/interview-new/models/interview.models';
import { LabelValueLowerGeneric } from '../../../models/keyvalue';
import { ITaskWrapper } from '../task.state.models';
import { IMemberCallManager } from './../../member/member.models';
import { ICommandContext, ICommandElementData, IInterviewParameterGetterOptions, IParseResult } from './command.models';
import { UtilitiesRegex } from '../../utilities.regex';

@Injectable({
    providedIn: 'root'
})
export class CommandParserService {


    parseContextData(command: string): any {
        const commandElements = CommandParserService.splitCommand(command);

        let result: any;

        if (commandElements.length >= 2) {
            result = CommandParserService.getCommandParameterValue(commandElements.slice(1), ['-CONTEXT-DATA:', '-DATA:', '-CONTEXT:', '--CONTEXT-DATA:', '--DATA:', '--CONTEXT:'], { mode: 'prefix' });
        }

        return result;
    }

    parse(command: string, customMetadata?: ICommandContext): any {

        const result = this.internalParse(command, customMetadata);
        return result.executableFunction;
    }

    parsedData(command: string, customMetadata?: ICommandContext): IParseResult {
        return this.internalParse(command, customMetadata);
    }

    private internalParse(command: string, customMetadata?: ICommandContext): IParseResult {
        const commandElements = CommandParserService.splitCommand(command);
        let result: IParseResult;
        if (commandElements.length >= 2) {
            const action = commandElements[0];
            switch (action.label.toUpperCase()) {
                case 'OPEN':
                    result = this.parseOpen(commandElements.slice(1), customMetadata);
                    break;
                case 'RUN':
                    result = this.parseRun(commandElements.slice(1), customMetadata);
                    break;
                default:
                    result = this.parseOpen(commandElements.slice(1), customMetadata);

            }
        }

        return result;
    }

    private static split(command: string) {
        const myRegexp = /[^\s"]+|"([^"]*)"/gi;
        const result: string[] = [];

        let match: RegExpExecArray;
        do {
            // Each call to exec returns the next regex match as an array
            match = myRegexp.exec(command);

            if (match != null) {
                // Index 1 in the array is the captured group if it exists
                // Index 0 is the matched text, which we use if no captured group exists
                result.push(match[1] ? match[1] : match[0]);
            }
        } while (match != null);

        return result;
    }

    private static splitCommand(command: string) {
        const commandElements = this.split(command).map(element => element.trim()).filter(element => element.length > 0);
        const keyValues: LabelValueLowerGeneric<ICommandElementData>[] = [];
        let previousElement: string;

        for (const element of commandElements) {

            if ((element.startsWith('-') && !UtilitiesRegex.numberElementRegex.test(element)) || !previousElement || !previousElement.startsWith('-')) {
                keyValues.push({ label: element, value: { values: [] } as ICommandElementData });
                previousElement = element;
            } else if (previousElement && previousElement.startsWith('-')) {
                keyValues[keyValues.length - 1].value.values.push(element);
            }
        }

        return keyValues;
    }

    private parseOpen(openCommandElements: LabelValueLowerGeneric<ICommandElementData>[], commandContext: ICommandContext): IParseResult {
        const target = openCommandElements[0].label.toUpperCase();
        let commandParse: any;
        switch (target) {
            case 'SURVEY':

                commandParse = {
                    customView: LazyLoadedWidgets.MEMBER_TASK_DIALOG,
                    customViewMetadata: {
                        ...commandContext,
                        displayName: ((commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.displayName) || CommandParserService.getCommandParameterValue(openCommandElements, ['-TITLE', '--T']),
                        description: ((commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.description) || CommandParserService.getCommandParameterValue(openCommandElements, ['-SUBTITLE', '--SUBT']),
                        icon: (commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.icon,

                        customView: LazyLoadedWidgets.TASK_MEMBER_SURVEY,
                        customViewMetadata: {
                            ...commandContext,


                        } as ICommandContext
                    } as ITaskDialogMetadata<ICommandContext>
                } as ILazyLoadContext<ITaskDialogMetadata<ICommandContext>>;

                return { executableFunction: this.createWrapperFunction(commandContext, commandParse, [this.hostCommandFn]), commandContext, commandParse };

            case 'MEMBER-GUARD':
                commandParse = {
                    customView: LazyLoadedWidgets.MEMBER_TASK_DIALOG,
                    customViewMetadata: {
                        ...commandContext,
                        displayName: ((commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.displayName) || CommandParserService.getCommandParameterValue(openCommandElements, ['-TITLE', '--T']),
                        description: ((commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.description) || CommandParserService.getCommandParameterValue(openCommandElements, ['-SUBTITLE', '--SUBT']),
                        icon: ((commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.icon) || CommandParserService.getCommandParameterValue(openCommandElements, ['-ICON', '--ICO']),

                        customView: LazyLoadedWidgets.MEMBER_GUARD_ADAPTER,
                        customViewMetadata: {
                            ...commandContext,


                        } as ICommandContext
                    } as ITaskDialogMetadata<ICommandContext>
                } as ILazyLoadContext<ITaskDialogMetadata<ICommandContext>>;

                return { executableFunction: this.createWrapperFunction(commandContext, commandParse, [this.hostCommandFn]), commandContext, commandParse };

            case 'MEMBER-RPC':

                commandParse = {
                    customView: LazyLoadedWidgets.MEMBER_TASK_DIALOG,
                    customViewMetadata: {
                        ...commandContext,
                        displayName: ((commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.displayName) || CommandParserService.getCommandParameterValue(openCommandElements, ['-TITLE', '--T']),
                        description: ((commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.description) || CommandParserService.getCommandParameterValue(openCommandElements, ['-SUBTITLE', '--SUBT']),
                        icon: ((commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.icon) || CommandParserService.getCommandParameterValue(openCommandElements, ['-ICON', '--ICO']),

                        customView: LazyLoadedWidgets.MEMBER_GUARD_ADAPTER,
                        customViewMetadata: {


                        } as ITaskInterviewMetadata
                    } as ITaskDialogMetadata<ITaskInterviewMetadata>
                } as ILazyLoadContext<ITaskDialogMetadata<ITaskInterviewMetadata>>;

                return { executableFunction: this.createWrapperFunction(commandContext, commandParse, [this.activateCallAsCommandFn, this.runCommandsFn]), commandContext, commandParse };

            default:
                const internalContext = commandContext || { host: undefined, command: { task: {} as TaskInfo } as ITaskCommandWrapper } as ICommandContext;
                const commandMetadata = CommandParserService.getCommandParameterValue(openCommandElements, ['-CONTEXT-DATA:', '-DATA:', '--CONTEXT:'], { mode: 'prefix' });
                const contextData = (internalContext.command as ITaskCommandWrapper).task?.contextData;
                const metadata = {
                    ...commandMetadata,
                    ...contextData
                };

                commandParse = {
                    customView: LazyLoadedWidgets.MEMBER_TASK_DIALOG,
                    customViewMetadata: {
                        ...commandContext,
                        displayName: ((commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.displayName) || CommandParserService.getCommandParameterValue(openCommandElements, ['-TITLE', '--T']),
                        description: ((commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.description) || CommandParserService.getCommandParameterValue(openCommandElements, ['-SUBTITLE', '--SUBT']),
                        icon: ((commandContext.command as ITaskWrapper).task && (commandContext.command as ITaskWrapper).task.icon) || CommandParserService.getCommandParameterValue(openCommandElements, ['-ICON', '--ICO']),

                        customView: CommandParserService.getCommandParameterValue(openCommandElements, ['-ADAPTER', '--ADAPTER', '--ADAP']),
                        customViewMetadata: {
                            hosted: target,
                            ...commandContext,
                            ...metadata
                        }
                    } as ITaskDialogMetadata<ICommandContext>
                } as ILazyLoadContext<ITaskDialogMetadata<ICommandContext>>;

                return { executableFunction: this.createWrapperFunction(commandContext, commandParse, [this.hostCommandFn]), commandContext, commandParse };
        }
    }

    private parseRun(openCommandElements: LabelValueLowerGeneric<ICommandElementData>[], commandContext: ICommandContext): IParseResult {

        const target = openCommandElements[0].label.toUpperCase();
        let commandParse: any;
        switch (target) {
            case 'CLOSE-SESSION':
                commandParse = {
                    customView: LazyLoadedWidgets.MEMBER_TASK_CLOSE_SESSION,
                    customViewMetadata: {
                        ...commandContext,
                    }
                };
                return { executableFunction: this.createWrapperFunction(commandContext, commandParse, [this.hostCommandFn]), commandContext, commandParse };
                break;

            case 'NAVIGATE':
                {
                    const context = CommandParserService.getCommandParameterValue(openCommandElements, ['-CONTEXT-DATA:', '-DATA:', '-CONTEXT:', '--CONTEXT-DATA:', '--DATA:', '--CONTEXT:'], { mode: 'prefix' });
                    commandParse = {
                        relativeUri: CommandParserService.getCommandParameterValue(openCommandElements, ['-RELATIVEURI', '--RELATIVEURI', '-URI', '--URI']),
                        queryParams: CommandParserService.getCommandParameterValue(openCommandElements, ['--QUERYPARAMS', '-QUERYPARAMS', '--QUERY', '-QUERY'], { mode: 'prefix' }),
                        context
                    };
                    return { executableFunction: this.createWrapperFunction(commandContext, commandParse, [this.navigateCommandFn]), commandContext, commandParse };
                }
                break;
            default:

                const internalContext = commandContext || { host: undefined, command: { task: {} as TaskInfo } as ITaskCommandWrapper } as ICommandContext;

                const commandMetadata = CommandParserService.getCommandParameterValue(openCommandElements, ['-CONTEXT-DATA:', '-DATA:', '--CONTEXT:'], { mode: 'prefix' });
                const contextData = (internalContext.command as ITaskCommandWrapper).task?.contextData;
                const metadata = {
                    ...commandMetadata,
                    ...contextData
                };
                const interviewType = CommandParserService.getCommandParameterValue(openCommandElements, ['-TYPE', '-INTERVIEW-TYPE', '--T']) || metadata.type;
                const byPassToSummaryRaw = CommandParserService.getCommandParameterValue(openCommandElements, ['--BYPASSTOSUMMARY', '--BYPASS-TOSUMMARY', '--BYPASS_TO_SUMMARY', '--BYPASTOSUMMARY', '--byPassToSummary']);
                const byPassToSummary = byPassToSummaryRaw !== undefined ? byPassToSummaryRaw.toString().toLowerCase() === 'true' : true;

                commandParse = {
                    customView: CommandParserService.getCommandParameterValue(openCommandElements, ['-TASKDIALOG', '-DIALOG', '--TASKDIALOG', '--DIALOG']) || LazyLoadedWidgets.MEMBER_TASK_DIALOG,

                    customViewMetadata: {
                        ...internalContext,
                        displayName: ((internalContext.command as ITaskWrapper).task && (internalContext.command as ITaskWrapper).task.displayName) || CommandParserService.getCommandParameterValue(openCommandElements, ['-TITLE', '--T']),
                        description: ((internalContext.command as ITaskWrapper).task && (internalContext.command as ITaskWrapper).task.description) || CommandParserService.getCommandParameterValue(openCommandElements, ['-SUBTITLE', '--SUBT']),
                        icon: ((internalContext.command as ITaskWrapper).task && (internalContext.command as ITaskWrapper).task.icon) || CommandParserService.getCommandParameterValue(openCommandElements, ['-ICON', '--ICO']),

                        // none: Means no header
                        customView: CommandParserService.getCommandParameterValue(openCommandElements, ['-ADAPTER', '--ADAP']) || LazyLoadedWidgets.TASK_INTERVIEW_ADAPTER,
                        customViewMetadata: {
                            ...internalContext,
                            package: CommandParserService.getCommandParameterValue(openCommandElements, ['-PACKAGE', '-PACKAGENAME', '--P']),
                            version: CommandParserService.getCommandParameterValue(openCommandElements, ['-VERSION', '-PACKAGEVERSION', '--V']),
                            type: interviewType,

                            dataProvider: CommandParserService.getCommandParameterValue(openCommandElements, ['-DATA-PROVIDER', '--PROVIDER']),
                            summaryComponent: CommandParserService.getCommandParameterValue(openCommandElements, ['-SUMMARY-COMPONENT', '--SUMMARY']),
                            contextData: {

                                type: interviewType,
                                entityId: contextData?.entityId || CommandParserService.getCommandParameterValue(openCommandElements, ['-ENTITYID', '--E']),
                                entityType: contextData?.entityType || CommandParserService.getCommandParameterValue(openCommandElements, ['-ENTITYTYPE', '-ENTITY-TYPE', '--ET']),
                                ...metadata
                            },

                        } as ITaskInterviewMetadata
                    } as ITaskDialogMetadata<ITaskInterviewMetadata>

                } as ILazyLoadContext<ITaskDialogMetadata<ITaskInterviewMetadata>>;

                if (
                    commandParse &&
                    commandParse.customViewMetadata &&
                    commandParse.customViewMetadata.customViewMetadata
                ) {
                    commandParse.customViewMetadata.customViewMetadata.byPassToSummary = byPassToSummary;
                }
                const executableFunction = this.createWrapperFunction(internalContext, commandParse, [this.hostCommandFn]);
                return { executableFunction, commandContext, commandParse };
                break;
        }

    }

    private static getCommandParameterValue(openCommandElements: LabelValueLowerGeneric<ICommandElementData>[], matches: string[], options?: IInterviewParameterGetterOptions): string | any | undefined {
        options = options || {} as IInterviewParameterGetterOptions;

        const tempElements = openCommandElements.map(item => {
            const result = JSON.parse(JSON.stringify(item));
            const labelUpper = result.label.toUpperCase();
            let matchItem: string;
            if (options.mode === 'prefix') {
                matchItem = matches.find(match => labelUpper.startsWith(match));
            } else {
                matchItem = matches.find(match => match === labelUpper);
            }
            if (matchItem) {
                result.value.metadata = { match: matchItem };
            }

            return result;
        });

        const matchingElements = tempElements.filter(item => {
            return !!item.value.metadata && !!item.value.metadata.match;
        });

        if (options.mode === 'prefix') {
            const newMatchedElements = matchingElements.map(matchElement => {
                let label = matchElement.label.substring(matchElement.value.metadata.match.length);
                label = label.replace(/^[:]/, '');
                return { ...matchElement, label };
            });
            return newMatchedElements.reduce((map, obj) => {
                map[obj.label] = obj.value.values[0];
                return map;
            }, {});
        } else if (matchingElements.length === 1) {
            return matchingElements[0].value.values[0];
        } else if (matchingElements.length > 1) {
            throw new Error('interview version was declared more that once');
        }
    }



    async createWrapperFunction(commandContext: ICommandContext, commandParse: any, functions: ((commandService: ICommandContext, commandParse: any) => Promise<void>)[]) {
        return (async () => {
            functions.forEach(fn => {
                fn(commandContext, commandParse);
            })
        });
    }


    async hostCommandFn(commandContext: ICommandContext, commandParse: any) {
        await commandContext.commandService.markCommandAsExecuting(commandContext.command, commandParse);
    }

    async activateCallAsCommandFn(commandContext: ICommandContext, commandParse: any) {
        const callManager = (commandContext.host as unknown as IMemberCallManager);
        callManager.setOnCall(true);
    }

    async runCommandsFn(commandContext: ICommandContext, commandParse: any) {
        commandContext.commandService.runCommands(true);
    }

    async navigateCommandFn(commandContext: ICommandContext, commandParse: any) {
        const relativeUri = commandParse.relativeUri;
        const queryParams = commandParse.queryParams || commandParse.context['queryParams'] || commandParse.context['Query'];
        const router = InjectorInstance.get<Router>(Router);
        router.navigate([relativeUri], { queryParams });
        // );

    }

    static getInterviewCommandConfig(interviewCommand: string, context?: any) {
        const commandElements = this.splitCommand(interviewCommand);
        const openCommandElements = commandElements.slice(2);

        const packageName = this.getCommandParameterValue(openCommandElements, ['-PACKAGE', '-PACKAGENAME', '--P']);
        const packageVersion = this.getCommandParameterValue(openCommandElements, ['-VERSION', '-PACKAGEVERSION', '--V']);

        const dataProvider = this.getCommandParameterValue(openCommandElements, ['-DATA-PROVIDER', '--PROVIDER']);
        const summaryComponent = this.getCommandParameterValue(openCommandElements, ['-SUMMARY-COMPONENT', '--SUMMARY']);
        const byPassToSummary = this.getCommandParameterValue(openCommandElements, ['-SUMMARY-BYPASS', '--BYPASSTOSUMMARY']);


        const type = this.getCommandParameterValue(openCommandElements, ['-TYPE', '-INTERVIEW-TYPE', '--T']) || context?.type;
        const entityId = this.getCommandParameterValue(openCommandElements, ['-ENTITYID', '--E']) || context?.entityId;
        let entityType = this.getCommandParameterValue(openCommandElements, ['-ENTITYTYPE', '-ENTITY-TYPE', '--ET']) || context?.entityType;

        const completion = context?.completion || 0;

        return {
            packageName,
            packageVersion,
            dataProvider,
            summaryComponent,
            type,
            entityId,
            entityType,
            completion,
            context,
            byPassToSummary
        } as IInterviewConfig;
    }
}
